<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("OTHER_SERVICE.show_order") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" v-if="orderData">
      <form>
        <div class="row">
          <!-- ============ Start:: Order Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.order_data_section") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.order_date')"
            v-model.trim="orderData.created_at"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.order_number')"
            v-model.trim="orderData.id"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.order_status')"
            v-model.trim="orderData.status_label"
            disabled
          />
          <!-- ============ End:: Order Data Section ============ -->

          <!-- ============ Start:: Cart Owner Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.cart_owner_data_section") }}</h4>
          </div>

          <base-image-upload-input
            col="12"
            :disabled="true"
            identifier="provider_avatar"
            :placeholder="$t('OTHER_SERVICE.cart_owner_logo')"
            :preSelectedImage="orderData.provider?.avatar"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('OTHER_SERVICE.cart_owner_name')"
            v-model.trim="orderData.provider.name"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('OTHER_SERVICE.average_rating')"
            v-model.trim="orderData.provider.rating"
            disabled
          />
          <!-- ============ End:: Cart Owner Data Section ============ -->

          <!-- ============ Start:: Customer Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.customer_data_section") }}</h4>
          </div>

          <base-image-upload-input
            col="12"
            :disabled="true"
            identifier="user_avatar"
            :placeholder="$t('OTHER_SERVICE.customer_image')"
            :preSelectedImage="orderData.user?.avatar"
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.customer_name')"
            v-model.trim="orderData.user.name"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.average_rating')"
            v-model.trim="orderData.user.rating"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.city')"
            v-model.trim="orderData.user.city"
            disabled
          />

          <!-- Map Component -->
          <div class="col-12" v-if="orderData.user?.latitude && orderData.user?.longitude">
            <label class="mb-2">{{ $t("OTHER_SERVICE.delivery_location_map") }}</label>
            <MapComponent
              :lat="parseFloat(orderData.user.latitude)"
              :lng="parseFloat(orderData.user.longitude)"
            />
          </div>
          <!-- ============ End:: Customer Data Section ============ -->

          <!-- ============ Start:: Horse Data Section ============ -->
          <div class="form_title_wrapper" v-if="orderData.horse">
            <h4>{{ $t("OTHER_SERVICE.horse_data_section") }}</h4>
          </div>

          <template v-if="orderData.horse">
            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.horse_name')"
              v-model.trim="orderData.horse.name"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.average_rating')"
              v-model.trim="orderData.horse.rating"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.breed_type')"
              v-model.trim="orderData.horse.breed"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.gender')"
              v-model.trim="orderData.horse.gender"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.age')"
              v-model.trim="orderData.horse.age"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.color')"
              v-model.trim="orderData.horse.color"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.health_status')"
              v-model.trim="orderData.horse.health_status"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.training_level')"
              v-model.trim="orderData.horse.training_level"
              disabled
            />
          </template>
          <!-- ============ End:: Horse Data Section ============ -->

          <!-- ============ Start:: Cart/Vehicle Data Section ============ -->
          <div class="form_title_wrapper" v-if="orderData.vehicle">
            <h4>{{ $t("OTHER_SERVICE.cart_data_section") }}</h4>
          </div>

          <template v-if="orderData.vehicle">
            <base-input
              col="6"
              type="textarea"
              rows="3"
              :placeholder="$t('OTHER_SERVICE.cart_description')"
              v-model.trim="orderData.vehicle.description"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.cart_type')"
              v-model.trim="orderData.vehicle.vehicle_type"
              disabled
            />
            <base-input
              col="3"
              type="text"
              :placeholder="$t('PLACEHOLDERS.cart_rate')"
              v-model.trim="orderData.provider.rating"
              disabled
            />
            <base-input
              col="3"
              type="text"
              :placeholder="$t('PLACEHOLDERS.rider_name')"
              v-model.trim="orderData.provider.name"
              disabled
            />

            <base-input
              col="3"
              type="text"
              :placeholder="$t('OTHER_SERVICE.cart_capacity')"
              v-model.trim="orderData.vehicle.capacity"
              disabled
            />
            <!-- Vehicle Images -->
            <div class="col-12" v-if="orderData.vehicle.images && orderData.vehicle.images.length">
              <label class="mb-2">{{ $t("OTHER_SERVICE.cart_images") }}</label>
              <div class="images_gallery">
                <img 
                  v-for="(image, index) in orderData.vehicle.images" 
                  :key="index"
                  :src="image" 
                  :alt="`Vehicle Image ${index + 1}`"
                  class="vehicle_image"
                />
              </div>
            </div>

            <!-- Vehicle Video -->
            <div class="col-12" v-if="orderData.vehicle.video">
              <label class="mb-2">{{ $t("OTHER_SERVICE.cart_video") }}</label>
              <video controls class="vehicle_video">
                <source :src="orderData.vehicle.video" type="video/mp4">
                {{ $t("GENERAL.video_not_supported") }}
              </video>
            </div>
          </template>
          <!-- ============ End:: Cart/Vehicle Data Section ============ -->

          <!-- ============ Start:: Booking Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.booking_data_section") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.booking_date')"
            v-model.trim="orderData.service_date"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.booking_time')"
            v-model.trim="orderData.service_time"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.pickup_location')"
            v-model.trim="orderData.pickup_location"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('OTHER_SERVICE.drop_location')"
            v-model.trim="orderData.drop_location"
            disabled
          />

          <base-input
            col="6"
            type="textarea"
            rows="3"
            :placeholder="$t('OTHER_SERVICE.notes')"
            v-model.trim="orderData.notes"
            disabled
          />

          <!-- Map for pickup location -->
          <div class="col-12" v-if="orderData.pickup_location_lat && orderData.pickup_location_lng">
            <label class="mb-2">{{ $t("OTHER_SERVICE.pickup_location") }} - {{ $t("OTHER_SERVICE.delivery_location_map") }}</label>
            <MapComponent
              :lat="parseFloat(orderData.pickup_location_lat)"
              :lng="parseFloat(orderData.pickup_location_lng)"
            />
          </div>

          <!-- Map for drop location -->
          <div class="col-12" v-if="orderData.drop_location_lat && orderData.drop_location_lng">
            <label class="mb-2">{{ $t("OTHER_SERVICE.drop_location") }} - {{ $t("OTHER_SERVICE.delivery_location_map") }}</label>
            <MapComponent
              :lat="parseFloat(orderData.drop_location_lat)"
              :lng="parseFloat(orderData.drop_location_lng)"
            />
          </div>
          <!-- ============ End:: Booking Data Section ============ -->

          <!-- ============ Start:: Price and Payment Data Section ============ -->
          <div class="form_title_wrapper">
            <h4>{{ $t("OTHER_SERVICE.price_payment_section") }}</h4>
          </div>

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.payment_method')"
            :value="getPaymentMethodLabel(orderData.payment_method)"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.service_price')"
            v-model.trim="orderData.sub_total"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.tax')"
            v-model.trim="orderData.tax"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.total')"
            v-model.trim="orderData.total"
            disabled
          />

          <base-input
            col="4"
            type="text"
            :placeholder="$t('OTHER_SERVICE.is_paid')"
            :value="orderData.is_paid ? $t('OTHER_SERVICE.paid') : $t('OTHER_SERVICE.not_paid')"
            disabled
          />
          <!-- ============ End:: Price and Payment Data Section ============ -->

        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import MapComponent from "../../../components/general/MapComponent.vue";

export default {
  name: "ShowOtherService",
  components: {
    MapComponent,
  },

  data() {
    return {
      isWaitingRequest: false,
      orderData: {
        provider: {},
        user: {},
        horse: null,
        vehicle: null,
      },
    };
  },

  methods: {
    // Start:: Show Order
    async showOrder() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `orders/${this.$route.params.id}`,
        });
        this.orderData = res.data.data.order;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(error.response?.data?.message || "Error loading order");
      }
    },
    // End:: Show Order

    // Start:: Get Payment Method Label
    getPaymentMethodLabel(method) {
      if (method === 'wallet') {
        return this.$t('PAYMENT_METHODS.wallet');
      } else if (method === 'online' || method === 'electronic') {
        return this.$t('PAYMENT_METHODS.electronic');
      }
      return method;
    },
    // End:: Get Payment Method Label
  },

  created() {
    // Start:: Fire Methods
    this.showOrder();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.form_title_wrapper {
  margin-top: 20px;
  margin-bottom: 15px;
}

.images_gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 15px;
  margin-top: 10px;
}

.vehicle_image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.vehicle_video {
  width: 100%;
  max-width: 600px;
  border-radius: 8px;
  margin-top: 10px;
}

label.mb-2 {
  font-weight: 600;
  color: #333;
  display: block;
}
</style>
